<template>
  <div class="mental-health-checkup-history">
    <h4 class="title">Riwayat konsultasi</h4>
    <div v-if="checkupHistories.length == 0" class="empty">
      Tidak ada riwayat konsultasi sebelumnya.
    </div>
    <template v-else>
      <div class="item-wrap">
        <div
          v-for="history in checkupHistories"
          :key="`checkup-${history.id}`"
          class="item"
        >
          <div class="d-flex align-items-center">
            {{ formatDateForHuman(history.scheduled_at, true) }}
            <material-icon name="circle" size="4" class="mx-2" />
            {{ formatTimeToIndo(history.schedule.time_start) }} -
            {{ formatTimeToIndo(history.schedule.time_end) }} WIB
          </div>
          <div class="psychologist">
            Psikolog: {{ history.psychologist.name }}
          </div>
        </div>
      </div>
      <button
        class="btn-show-all"
        @click="showAll = !showAll"
        v-tooltip.bottom="showAll ? 'Sembunyikan' : 'Tampilkan semua'"
      >
        <material-icon
          :name="showAll ? 'expand_less' : 'expand_more'"
          size="16"
          color="#666"
        />
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: "mental-health-checkup-history",
  props: ["data"],
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    checkupHistories() {
      const data = this.data ?? [];
      if (!data.length) return [];
      return this.showAll ? data : [data[0]];
    },
  },
};
</script>
